import {
  getCachedNews,
  loadNewsWithCache,
  newsCacheKeys,
} from './newsCache';
import {
  getAllNewsCount,
  loadAdminNewsPage as loadAdminNewsPageFromFirestore,
} from './newsService';

export const ADMIN_NEWS_PAGE_SIZE = 10;
export const ADMIN_NEWS_ORDER = 'publishedAt:desc';

export const buildAdminNewsPageCacheKey = ({
  page = 1,
  pageSize = ADMIN_NEWS_PAGE_SIZE,
  category = '',
  authorId = '',
} = {}) => newsCacheKeys.adminPage({
  page,
  limit: pageSize,
  category,
  authorId,
  order: ADMIN_NEWS_ORDER,
});

export const getCachedAdminNewsPage = (options = {}) => {
  return getCachedNews(buildAdminNewsPageCacheKey(options));
};

export const loadAdminNewsPage = ({
  page = 1,
  pageSize = ADMIN_NEWS_PAGE_SIZE,
  cursor = null,
  category = '',
  authorId = '',
} = {}) => {
  const cacheKey = buildAdminNewsPageCacheKey({
    page,
    pageSize,
    category,
    authorId,
  });

  return loadNewsWithCache(cacheKey, async () => {
    if (page > 1 && !cursor) {
      throw new Error(`Відсутній cursor для сторінки ${page}`);
    }

    const startedAt =
      process.env.NODE_ENV === 'development' ? performance.now() : 0;

    if (process.env.NODE_ENV === 'development') {
      console.debug(`[ADMIN NEWS REQUEST START] ${cacheKey}`);
    }

    const result = await loadAdminNewsPageFromFirestore({
      pageSize,
      cursor,
    });

    if (process.env.NODE_ENV === 'development') {
      console.debug(
        `[ADMIN NEWS REQUEST COMPLETE] ${cacheKey} `
        + `documents=${result.news.length} `
        + `duration=${(performance.now() - startedAt).toFixed(1)}ms`
      );
    }

    return result;
  });
};

export const loadAdminNewsCount = async () => {
  const startedAt =
    process.env.NODE_ENV === 'development' ? performance.now() : 0;
  const count = await getAllNewsCount();

  if (process.env.NODE_ENV === 'development') {
    console.debug(
      `[ADMIN NEWS COUNT COMPLETE] count=${count} `
      + `duration=${(performance.now() - startedAt).toFixed(1)}ms`
    );
  }

  return count;
};

export const getAdminNewsStateAfterDeletion = ({
  news,
  deletedId,
  currentPage,
  totalCount,
}) => {
  const remainingNews = news.filter((item) => item.id !== deletedId);

  return {
    news: remainingNews,
    currentPage:
      remainingNews.length === 0 && currentPage > 1
        ? currentPage - 1
        : currentPage,
    totalCount:
      typeof totalCount === 'number'
        ? Math.max(0, totalCount - 1)
        : totalCount,
  };
};
